import {
  RDS_COLOR_NEUTRAL_90,
  RDS_FONT_SIZE_13,
} from '@rally/ui-themes/dist/web/rally/tokens.es6';
import styled from 'styled-components';
import { MEDIA_QUERY } from '@pass-frontend/utility/style-helpers';

export const StyledPagination = styled.div`
  margin-top: 16px;

  &.hide-controls .previous,
  &.hide-controls .next {
    display: none;
  }

  .break-link span {
    color: #323334;
  }

  .paginationBtns {
    display: flex;
    justify-content: center;
    align-items: center;

    li {
      &.next {
        margin-left: 8px;
      }

      &:not(:last-child) {
        margin-right: 16px;
      }

      &.previous {
        margin-right: 24px;
      }

      &.next .rds-icon,
      &.previous .rds-icon {
        height: ${RDS_FONT_SIZE_13};
        width: ${RDS_FONT_SIZE_13};
      }

      &.paginationActive {
        &:not(:nth-last-child(2)) {
          margin-right: 8px;
        }
        &:nth-last-child(2) {
          margin-right: 0;
        }
      }

      &.paginationActive:not(:nth-child(2)) {
        margin-left: -8px;
      }
    }
  }

  .paginationBtns a {
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 700;
    line-height: 18px;
    color: #323334;

    &:hover {
      text-decoration: none;
    }

    &:focus {
      outline: none;
    }

    &:focus-visible {
      outline: 2px solid -webkit-focus-ring-color;
    }
  }

  .paginationActive a {
    width: 38px;
    height: 38px;
    color: white;
    background-color: #323334;
  }

  .paginationDisabled {
    display: none;
  }

  ${MEDIA_QUERY.desktop} {
    margin-top: 32px;

    .paginationBtns {
      li {
        &:not(:last-child) {
          margin-right: 24px;
        }

        &.previous {
          margin-right: 32px;
        }

        &.paginationActive {
          &:not(:nth-last-child(2)) {
            margin-right: 16px;
          }
        }
      }
    }
  }
`;

export const StyledInfo = styled.div`
  margin-top: 24px;
  margin-bottom: 8px;
`;

export const StyledGymList = styled.div`
  box-sizing: border-box;
  padding: 24px 16px;
  border: 1px solid ${RDS_COLOR_NEUTRAL_90};
  border-radius: 8px;
  width: 100%;

  ${MEDIA_QUERY.desktop} {
    padding: 16px 24px 24px;
    height: 736px;
    max-width: 444px;
    overflow-y: scroll;
    border-radius: 8px 0px 0px 8px;

    &.more-padding {
      padding: 24px;
    }
  }
`;

export const StyledLandingListMessage = styled.div`
  border-radius: 50%;
  width: 256px;
  height: 256px;
  margin: auto;

  ${MEDIA_QUERY.desktop} {
    width: 379px;
    height: 379px;
  }
`;
